/**
 * External Imports
 */
import { FC } from 'react';
import { connect, useDispatch } from 'react-redux';

/**
 * Nexus Imports
 */
import { NeuButton } from '@neutron/react';

/**
 * Internal Imports
 */
import { RootState } from '../../../../redux/store';
import {
  openModal,
  setModalType,
  setModalData
} from '../../../../redux/actions';

/**
 * Global Type Definition Imports
 */
import { Employee, Patient } from '../../../../config/interfaces';

interface AddFbFromRoundBtnProps {
  modalData: Patient | Employee;
  type: string;
}
const AddFbFromRoundBtn: FC<AddFbFromRoundBtnProps> = ({ modalData, type }) => {
  const dispatch = useDispatch();

  const handleAddNewFb = () => {
    if (type === 'patient') {
      dispatch(setModalType('Add Patient Feedback On Rounds'));
      dispatch(setModalData(modalData));
      dispatch(openModal());
    } else if (type === 'employee') {
      dispatch(setModalType('Add Employee Feedback On Rounds'));
      dispatch(setModalData(modalData));
      dispatch(openModal());
    } else {
      dispatch(setModalType('Add Support Feedback On Rounds'));
      dispatch(setModalData(modalData));
      dispatch(openModal());
    }
  };

  return (
    <NeuButton
      data-testid="add-feedback-from-round-button"
      className="mx-2"
      color="blue"
      icon="campaign"
      kind="secondary"
      size="small"
      onClick={handleAddNewFb}
    >
      Add Feedback
    </NeuButton>
  );
};

const mapReduxStateToProps = (state: RootState) => {
  return {
    authorizedUser: state.AuthorizedUser.authorizedUser,
    modalState: state.ModalReducer.modal
  };
};

export default connect(mapReduxStateToProps)(AddFbFromRoundBtn);
